import axios from "../axios-auth";
import orginal_axios from "axios";


export const categoryService = {
  getCategoryList,
  saveCategory,
  getCategoryDetail,
  getCategoriesByStatus,
  getAllCategory,
  saveCategoryExcel,
  getCategoryExcelTemplate,
  exportAllCategory
};

function getCategoryList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/categories", { params });
}

function saveCategory(category) {
  if (!category.id) {
    // new category
    return axios.post("/auth/category", category);
  } else {
    // edit
    return axios.put("/auth/category", category);
  }
}

function getCategoryDetail(id) {
  return axios.get("/auth/category/" + id);
}

function getCategoriesByStatus(status) {
  return axios.get("/auth/categories-by-status/" + status);
}

function getAllCategory() {
  return axios.get("/auth/all-category");
}

function saveCategoryExcel(file) {
  return axios.post('/auth/category-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function getCategoryExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/category-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function exportAllCategory(searchParams) {
  let params = {};
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/category-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

